import React from 'react';
import {Link} from  "react-router-dom";
import pic from "../img/404.png";

export default function Page404() {
  return (
    <div className='page-404'>
      <img src= {pic}/>
      <h3>Oops! We can't find the page you're looking for.🧐</h3>
      <Link to= "/">Back to Home Page</Link>
    </div>
  )
}
